function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
/**
 * NFT capability registry — actions in the floating toolbar over artwork.
 *
 * Built-ins live here. Modules may:
 *   - call overlay.capabilities.register({ id, icon, label, description, visible, onActivate })
 *   - or respondTo('saito-nft-capabilities') with one capability object, or
 *     { capabilities: [ ... ] } for several
 *
 * Toolbar capabilities render as `.saito-nft-capability[data-capability="<id>"]`
 * inside `.saito-nft-capabilities`. Details stays in the registry but is not
 * drawn in that collection; the metadata footer chevron calls its onActivate.
 * Action hooks keep legacy class names (send-nft, sell-nft, …) for wiring.
 *
 * DOWNLOAD asks respondTo('saito-nft-download') first; otherwise falls back to
 * nft.image or the serialized NFT transaction.
 */

function triggerBrowserDownload(href, filename) {
  var a = document.createElement('a');
  a.href = href;
  a.download = filename || 'download';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
var BUILTIN_CAPABILITIES = [{
  id: 'transfer',
  icon: 'fa-solid fa-paper-plane',
  label: 'Transfer',
  description: 'Transfer this NFT to another wallet.',
  className: 'send-nft',
  visible: function visible() {
    return true;
  }
}, {
  id: 'list',
  icon: 'fa-solid fa-cart-shopping',
  label: 'Sell',
  description: 'List this NFT for sale in the Saito Store.',
  className: 'sell-nft',
  visible: function visible(ctx) {
    var _ctx$app$modules, _ctx$app$modules$retu;
    return Boolean((_ctx$app$modules = ctx.app.modules) === null || _ctx$app$modules === void 0 || (_ctx$app$modules$retu = _ctx$app$modules.returnFirstRespondTo) === null || _ctx$app$modules$retu === void 0 ? void 0 : _ctx$app$modules$retu.call(_ctx$app$modules, 'saito-sell-nft'));
  }
}, {
  id: 'download',
  icon: 'fa-solid fa-download',
  label: 'Download',
  description: 'Download the media associated with this NFT.',
  className: 'download-nft',
  visible: function visible() {
    return true;
  },
  onActivate: function () {
    var _onActivate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(ctx) {
      var app, nft, handler, filename, mimeMatch, _mimeMatch$1$split$, ext, json, blob, url, sig;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            app = ctx.app, nft = ctx.nft;
            if (nft) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            handler = app.modules.returnFirstRespondTo('saito-nft-download', nft);
            if (!(typeof (handler === null || handler === void 0 ? void 0 : handler.download) === 'function')) {
              _context.n = 3;
              break;
            }
            _context.n = 2;
            return handler.download(app, nft);
          case 2:
            return _context.a(2);
          case 3:
            if (!nft.image) {
              _context.n = 4;
              break;
            }
            filename = String(nft.title || 'nft-image').replace(/[^\w.-]+/g, '_') || 'nft-image';
            mimeMatch = String(nft.image).match(/^data:([^;,]+)/);
            if (mimeMatch && !filename.includes('.')) {
              ext = ((_mimeMatch$1$split$ = mimeMatch[1].split('/')[1]) === null || _mimeMatch$1$split$ === void 0 ? void 0 : _mimeMatch$1$split$.split('+')[0]) || 'bin';
              filename = "".concat(filename, ".").concat(ext);
            }
            triggerBrowserDownload(nft.image, filename);
            return _context.a(2);
          case 4:
            if (!(nft.tx && typeof nft.tx.serialize_to_web === 'function')) {
              _context.n = 5;
              break;
            }
            json = nft.tx.serialize_to_web(app);
            blob = new Blob([json], {
              type: 'application/json'
            });
            url = URL.createObjectURL(blob);
            sig = String(nft.tx.signature || nft.tx_sig || 'unknown').replace(/[^\w.-]+/g, '_').slice(0, 12);
            triggerBrowserDownload(url, "nft-".concat(sig, ".saito"));
            URL.revokeObjectURL(url);
            return _context.a(2);
          case 5:
            siteMessage('Nothing available to download', 2000);
          case 6:
            return _context.a(2);
        }
      }, _callee);
    }));
    function onActivate(_x) {
      return _onActivate.apply(this, arguments);
    }
    return onActivate;
  }()
}, {
  id: 'details',
  icon: 'fa-solid fa-circle-info',
  label: 'Details',
  description: 'View NFT metadata, slips, and advanced options.',
  className: 'details-nft',
  visible: function visible() {
    return true;
  },
  onActivate: function onActivate(ctx) {
    var p = document.querySelector('.saito-nft-overlay.panels');
    if (!p) {
      return;
    }
    if (p.classList.contains('saito-nft-mode-info')) {
      var _ctx$overlay;
      p.classList.remove('saito-nft-mode-info');
      (_ctx$overlay = ctx.overlay) === null || _ctx$overlay === void 0 || (_ctx$overlay = _ctx$overlay.capabilities) === null || _ctx$overlay === void 0 || _ctx$overlay.setActive('');
    } else {
      p.classList.add('saito-nft-mode-info');
      p.classList.remove('saito-nft-mode-send');
    }
  }
}];
var NFTCapabilities = /*#__PURE__*/function () {
  function NFTCapabilities(app, mod, overlay) {
    _classCallCheck(this, NFTCapabilities);
    this.app = app;
    this.mod = mod;
    this.overlay = overlay;
    /** @type {Array<object>} */
    this.registered = [];
    this.active_id = '';
  }

  /**
   * Register an extra capability (e.g. from a specialized NFT type).
   * Replaces an existing entry with the same id.
   */
  return _createClass(NFTCapabilities, [{
    key: "register",
    value: function register() {
      var capability = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!capability.id || !capability.icon || !capability.label) {
        return;
      }
      this.registered = this.registered.filter(function (c) {
        return c.id !== capability.id;
      });
      this.registered.push(capability);
    }
  }, {
    key: "context",
    value: function context() {
      var _this$overlay;
      return {
        app: this.app,
        mod: this.mod,
        overlay: this.overlay,
        nft: (_this$overlay = this.overlay) === null || _this$overlay === void 0 ? void 0 : _this$overlay.nft
      };
    }

    /**
     * Ordered visible capabilities for the current NFT.
     */
  }, {
    key: "list",
    value: function list() {
      var _this$app$modules, _this$app$modules$get;
      var ctx = this.context();
      var peers = ((_this$app$modules = this.app.modules) === null || _this$app$modules === void 0 || (_this$app$modules$get = _this$app$modules.getRespondTos) === null || _this$app$modules$get === void 0 ? void 0 : _this$app$modules$get.call(_this$app$modules, 'saito-nft-capabilities', ctx)) || [];
      var peerList = [];
      var _iterator = _createForOfIteratorHelper(peers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p = _step.value;
          if (Array.isArray(p === null || p === void 0 ? void 0 : p.capabilities)) {
            peerList.push.apply(peerList, _toConsumableArray(p.capabilities));
          } else if (p !== null && p !== void 0 && p.id && p !== null && p !== void 0 && p.icon && p !== null && p !== void 0 && p.label) {
            peerList.push(p);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var merged = [];
      var seen = new Set();
      for (var _i = 0, _arr = [].concat(BUILTIN_CAPABILITIES, _toConsumableArray(this.registered), peerList); _i < _arr.length; _i++) {
        var cap = _arr[_i];
        if (!(cap !== null && cap !== void 0 && cap.id) || seen.has(cap.id)) {
          continue;
        }
        var visible = typeof cap.visible === 'function' ? cap.visible(ctx) : cap.visible !== false;
        if (!visible) {
          continue;
        }
        seen.add(cap.id);
        merged.push(cap);
      }
      return merged;
    }

    /**
     * Toolbar actions. Details is opened from the metadata footer.
     */
  }, {
    key: "toolbarList",
    value: function toolbarList() {
      return this.list().filter(function (cap) {
        return cap.id !== 'details';
      });
    }
  }, {
    key: "renderHtml",
    value: function renderHtml() {
      return this.toolbarList().map(function (cap) {
        var actionClass = cap.className ? " ".concat(cap.className) : '';
        return "\n        <button\n          type=\"button\"\n          class=\"saito-nft-capability saito-large-square-button saito-glass".concat(actionClass, "\"\n          data-capability=\"").concat(cap.id, "\"\n          data-description=\"").concat(String(cap.description || cap.label).replace(/"/g, '&quot;'), "\"\n          aria-label=\"").concat(cap.label, "\"\n          aria-pressed=\"false\"\n        >\n          <span class=\"saito-icon-button\">\n            <i class=\"").concat(cap.icon, "\" aria-hidden=\"true\"></i>\n          </span>\n          <span class=\"saito-nft-capability-label\">").concat(cap.label, "</span>\n        </button>\n      ");
      }).join('');
    }
  }, {
    key: "footerMetaHtml",
    value: function footerMetaHtml(nft) {
      var _nft$returnType;
      var type = (nft === null || nft === void 0 || (_nft$returnType = nft.returnType) === null || _nft$returnType === void 0 ? void 0 : _nft$returnType.call(nft)) || (nft === null || nft === void 0 ? void 0 : nft.nft_type) || 'NFT';
      var creator = (nft === null || nft === void 0 ? void 0 : nft.creator) || '—';
      var id = (nft === null || nft === void 0 ? void 0 : nft.id) || '—';
      var shortId = id.length > 18 ? "".concat(id.slice(0, 18), "\u2026") : id;
      var shortCreator = creator.length > 14 ? "".concat(creator.slice(0, 8), "\u2026").concat(creator.slice(-4)) : creator;
      return "\n      <div class=\"meta-col\">\n        <span class=\"meta-label\">Type</span>\n        <span class=\"meta-value\">".concat(type, "</span>\n      </div>\n      <div class=\"meta-col\">\n        <span class=\"meta-label\">Creator</span>\n        <span class=\"meta-value\">").concat(shortCreator, "</span>\n      </div>\n      <div class=\"meta-col\">\n        <span class=\"meta-label\">ID</span>\n        <span class=\"meta-value\">").concat(shortId, "</span>\n      </div>\n    ");
    }
  }, {
    key: "showDescription",
    value: function showDescription() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var desc = document.querySelector('.saito-nft-panel-view .saito-nft-capability-desc');
      if (!desc) {
        return;
      }
      desc.textContent = text || '';
      desc.classList.toggle('is-empty', !text);
    }
  }, {
    key: "setActive",
    value: function setActive() {
      var _this = this;
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var root = document.querySelector('.saito-nft-panel-view .saito-nft-capabilities');
      if (!root) {
        return;
      }
      this.active_id = id || '';
      root.querySelectorAll('.saito-nft-capability').forEach(function (btn) {
        var on = btn.getAttribute('data-capability') === _this.active_id;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (this.active_id) {
        var btn = root.querySelector("[data-capability=\"".concat(this.active_id, "\"]"));
        this.showDescription((btn === null || btn === void 0 ? void 0 : btn.getAttribute('data-description')) || '');
      } else {
        this.showDescription('');
      }
    }
  }, {
    key: "openDetails",
    value: function openDetails() {
      var cap = this.list().find(function (entry) {
        return entry.id === 'details';
      });
      if (typeof (cap === null || cap === void 0 ? void 0 : cap.onActivate) === 'function') {
        cap.onActivate(this.context());
      }
    }
  }, {
    key: "attachDetailsNav",
    value: function attachDetailsNav() {
      var _this2 = this;
      var button = document.querySelector('.saito-nft-panel-view .saito-nft-footer-details');
      if (!button || button.dataset.detailsBound === '1') {
        return;
      }
      button.dataset.detailsBound = '1';
      button.addEventListener('click', function (e) {
        e.preventDefault();
        _this2.openDetails();
      });
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      this.attachDetailsNav();
      var root = document.querySelector('.saito-nft-panel-view .saito-nft-capabilities');
      if (!root || root.dataset.capabilitiesBound === '1') {
        return;
      }
      root.dataset.capabilitiesBound = '1';
      root.addEventListener('pointerover', function (e) {
        var btn = e.target.closest('.saito-nft-capability');
        if (!btn || !root.contains(btn)) {
          return;
        }
        _this3.showDescription(btn.getAttribute('data-description') || '');
      });
      root.addEventListener('pointerleave', function () {
        if (_this3.active_id) {
          var btn = root.querySelector("[data-capability=\"".concat(_this3.active_id, "\"]"));
          _this3.showDescription((btn === null || btn === void 0 ? void 0 : btn.getAttribute('data-description')) || '');
        } else {
          _this3.showDescription('');
        }
      });
      root.addEventListener('focusin', function (e) {
        var btn = e.target.closest('.saito-nft-capability');
        if (!btn || !root.contains(btn)) {
          return;
        }
        _this3.showDescription(btn.getAttribute('data-description') || '');
      });
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.saito-nft-capability');
        if (!btn || !root.contains(btn)) {
          return;
        }
        var id = btn.getAttribute('data-capability');
        _this3.setActive(id);
        var cap = _this3.list().find(function (c) {
          return c.id === id;
        });
        if (typeof (cap === null || cap === void 0 ? void 0 : cap.onActivate) === 'function') {
          e.preventDefault();
          cap.onActivate(_this3.context());
        }
      });
    }
  }]);
}();
module.exports = NFTCapabilities;